import styled, { css } from "styled-components";
import { BaseButton } from "@shared/styles/common.styled";

const fontStyles = css`
  font-family: "Lato";
  line-height: 1;
  font-size: 1rem;
`;

export const HeaderWrapper = styled.div`
  background: #15aee5;
  display: flex;
  justify-content: space-between;
  padding: 1.375rem;
`;

export const Title = styled.h2`
  font-size: 1.125rem;
  color: white;
  font-family: "Lato";
  line-height: 1;
  margin: 0;
  text-transform: initial;
`;

export const FileImageWrapper = styled.label`
  margin-top: 10px;
  border-radius: 40px;
  margin-left: 10px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1.375rem;
  margin-top: ${(props) => props.marginTop ?? "10px;"};
  padding-top: 0px;
`;

export const MapContainer = styled.div`
  border-radius: 4px;
  position: relative;
  height: 300px;
  overflow: hidden;
  outline: none;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border: solid 1px #00aeea;
`;

export const ContentDiv = styled.div`
  max-height: 60vh;
  padding: 0 2.375rem;
  overflow-y: auto;
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: ${(props) => props.align ?? "center"};
  > div {
    margin-right: 1rem;
  }
`;
export const SectionContainer = styled.section`
  width: 100%;
`;

export const FormBody = styled.div`
  max-height: 60vh;
  padding: 0 1.375rem;
  overflow-y: auto;
`;

export const OuterWrapper = styled.div`
  padding: 1.375rem;
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column};
  gap: 1.25rem;
  margin-bottom: 20px;
`;

export const MarginDiv = styled.div`
  ${(props) => props.marginInfo};
`;

export const CheckboxGridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column};
`;

export const RequiredMessage = styled.p`
  width: 100%;
  color: red;
  font-size: 0.875rem;
  font-family: "Lato";
  line-height: 1;
  margin: 0;
  padding: 0;
  max-width: 200px;
`;

export const ComponentContainer = styled.div`
  height: 300px;
  border: 1px solid;
  border-color: ${(props) => (props.error ? "red" : "#1BACE4")};
  padding: 10px;
  overflow: auto;
`;

export const ErrorLabel = styled.span`
  font-weight: bold;
  color: red;
  font-style: italic;
  float: left;
`;

export const ComponentContainerEmpty = styled.div`
  height: 300px;
  border: 1px solid;
  border-color: ${(props) => (props.error ? "red" : "#1BACE4")};
  text-align: center;
  line-height: 300px;
`;

export const ContainerLabel = styled.label`
  width: auto;
  color: #ff5200;
  font-family: "Lato";
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 1;
  text-align: center;
  text-align: left;
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const CreateButton = styled(BaseButton)`
  background: #00aeea;
  border: 1px solid #00aeea;
  font-weight: normal;
  width: auto;
  font-size: 16px;
  font-family: lato;
  margin-bottom: 5rem;
  line-height: 35px;
  margin-left: ${(props) => props?.marginRight};
`;

export const FilterFlexRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
`;
export const ButtonInnerWrapper = styled.div`
  padding-top: 10px;
`;
